<template>
  <modal
    width="40"
    :showModal="showModal"
    @close-modal="closeModal"
    :showCancleBtn="false"
    :clickOutside="false"
  >
    <div class="w-full">
      <div class=" justify-center flex mt-12">
        <Img class="book_icon" src="/icons/circle-double-check.svg"/>
      </div>
      <h2 class="book_header">Booking Confirmed!</h2>
      <p class="book_text">{{ this.shipingService && this.shipingService.orgName ? this.shipingService.orgName : "N/A" }} will dispatch a 30 Tonne Open Body Truck shortly after final confirmation.</p>
      <div>
        <Button class="book_btn" @click="close">Close</Button>
      </div>
    </div>
  </modal>
</template>

<script>
// import Modal from "@/components/partials/Modal/index";
export default {
  components: {
    // Modal,
  },
  props: {
    shipingService: {
      required: false
    },
    moveToHome: {
      type: Function,
      required: false,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },

  },
  data() {
    return {
      selectedModule: null,
      moduleOptions: [],
      loading: false,
    };
  },
  methods: {
    close() {
      this.moveToHome()
    },
  },
};
</script>

<style scoped>
.book_header{
  @apply text-xl font-semibold text-center w-full mb-3 mt-4;
}
.book_text{
  @apply text-center w-full mb-16;
}
.book_btn{
  @apply w-full bg-primary-yellow py-3 text-center rounded-md font-[500]
}
.book_icon{
  @apply w-[45px] h-[45px]
}
</style>
